module.exports = __webpack_public_path__ + "media/bootstrap-icons/symmetry-vertical-c3a2075b.svg";